// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__minervaModern_9defb7', '__minervaModern_Fallback_9defb7'"},"className":"__className_9defb7","variable":"__variable_9defb7"};